import { render } from "./TaskList.vue?vue&type=template&id=06fd0aa9&scoped=true"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"

import "./TaskList.vue?vue&type=style&index=0&id=06fd0aa9&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue practice\\My Vue3Projects\\todo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06fd0aa9"]])

export default __exports__